// #3447 - DETECTING a new build. registerType is "prompt", so a new service
// worker installs and waits, but the browser only looks for a new sw.js on a
// full navigation, and a kiosk SPA never does one. Without a timed check a
// tablet kept heartbeating an old build for hours after a deploy (HITS Del Mar
// 2026-10-16: three tablets still on the pre-fix build 40 minutes after the fix
// was live). This asks the browser to re-fetch sw.js on a timer and whenever
// the page becomes visible again (a tablet waking from sleep).
//
// It only DETECTS. When the update lands in `waiting`, vite-plugin-pwa's
// useRegisterSW flips needRefresh and ReloadPrompt applies it on a safe route
// only (shouldAutoApplyUpdate), so this never reloads a scribe mid-ride.
//
// A failed check (offline, flaky venue wifi) is swallowed: the next tick tries
// again, and the manual "Check for updates" dialog (swUpdateCheck.js) is the
// path that reports a failure to a person.

export const DEFAULT_UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;
// A tablet flicking between apps fires visibilitychange often; each check is a
// sw.js fetch on venue wifi, so skip one made within this window of the last.
export const MIN_VISIBILITY_CHECK_GAP_MS = 30 * 1000;

// Returns a stop() that removes the timer and the listener.
export function startPeriodicUpdateCheck(
  registration,
  {
    intervalMs = DEFAULT_UPDATE_CHECK_INTERVAL_MS,
    doc = typeof document !== "undefined" ? document : undefined,
  } = {},
) {
  let lastCheckAt = -Infinity;
  const check = () => {
    lastCheckAt = Date.now();
    try {
      Promise.resolve(registration.update()).catch(() => {});
    } catch {
      // update() threw synchronously (unregistered worker): try again next tick.
    }
  };
  const timer = setInterval(check, intervalMs);
  const onVisibility = () => {
    if (doc?.visibilityState !== "visible") return;
    if (Date.now() - lastCheckAt < MIN_VISIBILITY_CHECK_GAP_MS) return;
    check();
  };
  doc?.addEventListener("visibilitychange", onVisibility);
  return () => {
    clearInterval(timer);
    doc?.removeEventListener("visibilitychange", onVisibility);
  };
}
